module.exports = __webpack_public_path__ + "img/7_87.12b52d30.png";